import React, { useEffect, useState } from 'react';
import { IconPlayerPlay, IconVideo } from '@tabler/icons-react';
import './VideoSlideOverlay.css';

const VideoSlideOverlay = ({
  label = 'Video',
  loadingLabel = 'Loading video',
  progress = null,
  progressFillRef = null,
  isLoading = false,
}) => {
  // The play pulse is a decorative ~1s flash whose disappearance is driven by
  // a CSS animation ending at opacity 0. Under prefers-reduced-motion the
  // animation is disabled and the icon would otherwise stay pinned on screen
  // (e.g. iOS with Reduce Motion enabled), so unmount it on a timer slightly
  // longer than the animation — a no-op where the fade already ran.
  const [pulseDone, setPulseDone] = useState(false);
  useEffect(() => {
    if (isLoading || pulseDone) {
      return undefined;
    }
    const timer = setTimeout(() => setPulseDone(true), 1200);
    return () => clearTimeout(timer);
  }, [isLoading, pulseDone]);

  const progressStyle = Number.isFinite(progress) ? {
    transform: `scaleX(${Math.max(0, Math.min(1, progress))})`,
  } : undefined;

  if (isLoading) {
    return (
      <div className="video-slide-overlay loading" aria-hidden="true">
        <span className="video-slide-loading-indicator" />
        <span className="video-slide-loading-label">{loadingLabel}</span>
      </div>
    );
  }

  return (
    <div className="video-slide-overlay" aria-hidden="true">
      <span className="video-slide-badge">
        <IconVideo size={16} stroke={2.2} />
        <span>{label}</span>
      </span>
      {!pulseDone && (
        <span className="video-slide-play-pulse">
          <IconPlayerPlay size={30} stroke={2.4} />
        </span>
      )}
      <span className="video-slide-progress">
        <span
          ref={progressFillRef}
          className="video-slide-progress-fill"
          style={progressStyle}
        />
      </span>
    </div>
  );
};

export default VideoSlideOverlay;
